<div class="spinner-container">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
</div>

